// import type { Configuration } from '@repo/api-gw-sdk';
import {
  ConnectAzureBackupAccountApi,
  ConnectAzureBackupApplicationsApi,
  ConnectAzureSourceAccountApi,
  ConnectAzureVaultAccountApi,
  type Configuration,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

export const onboarding = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const connectAppApi = new ConnectAzureBackupApplicationsApi(config);
  const connectSourceApi = new ConnectAzureSourceAccountApi(config);
  const connectBackupApi = new ConnectAzureBackupAccountApi(config);
  const connectVaultApi = new ConnectAzureVaultAccountApi(config);

  return {
    appModule: {
      deploy: async (data: {
        customerTenantId: string;
        eonBackupApplicationName: string;
        eonBackupApplicationServicePrincipalId: string;
        customerBackupAppId: string;
        customerBackupAppServicePrincipalId: string;
      }) => {
        try {
          const response = await connectAppApi.connectAzureBackupApplications(
            currentProjectId,
            {
              eonBackupServicePrincipalId:
                data.eonBackupApplicationServicePrincipalId,
              customerBackupApplicationId: data.customerBackupAppId,
              customerBackupServicePrincipalId:
                data.customerBackupAppServicePrincipalId,
              customerTenantId: data.customerTenantId,
            }
          );
          return response;
        } catch (error) {
          console.error('Error calling connectAzureBackupApplications:', error);
          throw error;
        }
      },
    },
    backupAccount: {
      deploy: (data: {
        tenantId: string;
        backupSubscriptionId: string;
        regionName: string;
        adxClusterId: string;
        adxClusterIdentity: string;
        adxClusterUri: string;
      }) => {
        return connectBackupApi.connectAzureBackupAccount(currentProjectId, {
          tenantId: data.tenantId,
          subscriptionId: data.backupSubscriptionId,
          location: data.regionName,
          adxClusterId: data.adxClusterId,
          adxIdentity: data.adxClusterIdentity,
          adxClusterUri: data.adxClusterUri,
        });
      },
    },
    vaultAccount: {
      deploy: (data: { tenantId: string; vaultSubscriptionId: string }) => {
        return connectVaultApi.connectAzureVaultAccount(currentProjectId, {
          tenantId: data.tenantId,
          subscriptionId: data.vaultSubscriptionId,
        });
      },
    },
    sourceAccount: {
      deploy: (data: {
        tenantId: string;
        sourceSubscriptionId: string;
        sourceManagementGroupId: string;
      }) => {
        return connectSourceApi.connectAzureSourceAccount(currentProjectId, {
          tenantId: data.tenantId,
          subscriptionId: data.sourceSubscriptionId,
          managementGroupId: data.sourceManagementGroupId,
        });
      },
    },
  };
};
